module.exports = __webpack_public_path__ + "img/resource-tech-image-37.6ef37749.jpg";